/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getConvos.defs'
export { main as default } from './getConvos.defs'
